export default __webpack_public_path__ + "4ff9ae9667d231bed4135aeedd2f3b74.png";